// extracted by mini-css-extract-plugin
module.exports = {"container":"g_n3xUvOHnN_h1QQjLx2T","groupsList":"_1NNs5UET39wxqVtVX6Wzt4"};